import State from "@/helpers/pattern/state";
import { PopEntryExit } from "@/models/operativos/popEntryExit";
import { modelIsModified } from "@/helpers/vue-mc";
import popEntryExitAPI from "@/services/operativos/popEntryExit";
import CombosAPI from "@/services/catalogos";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { setSelectsInactiveDataName } from "@/helpers/form-common";
import { TIPO_POP_NUM_ENTRY } from "@/constants/operativos";

/**
 * State Pattern for popEntryExit form
 */
export default class PopEntryExitStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.popEntryExit = new PopEntryExit();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.popEntryExit) || $data.view.action.submit.busy || !modelIsModified($data.popEntryExit);
      }
      , async loadSelectsData({ $data }) {
        const { data: { results: { combo: popexitList } } } = await CombosAPI.get({ option: "popexit" });
        $data.view.elem.select.defaults.filteredList = popexitList ? popexitList.filter((value) => value.status) : [];
        $data.view.elem.select.defaults.filteredListAlt = popexitList ? popexitList.filter((value) => value.status && value.name != "NO") : [];
        $data.view.elem.select.defaults.completeList = popexitList || [];
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.loadSelectsData();
          this.resetValidators();

          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, tipo, defaults, multiple, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await popEntryExitAPI.save({
              clave: null
              , descripcion
              , tipo: tipo.join()
              , defaults: tipo.includes(TIPO_POP_NUM_ENTRY) ? defaults : null
              , multiple
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.popEntryExitTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, tipo, defaults, multiple, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          // Set options to combos if not are active
          if (defaults) setSelectsInactiveDataName(defaults, $data.view.elem.select.defaults.completeList, $data.view.elem.select.defaults.filteredList);

          $data.popEntryExit = new PopEntryExit({
            clave
            , descripcion
            , tipo: tipo.split(",")
            , defaults: tipo.split(",").includes(TIPO_POP_NUM_ENTRY) && defaults ? defaults : null
            , multiple
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, descripcion, tipo, defaults, multiple, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await popEntryExitAPI.update({
              clave
              , descripcion
              , tipo: tipo.join()
              , defaults: tipo.includes(TIPO_POP_NUM_ENTRY) ? defaults : null
              , multiple
              , status
            });

            $data.$refs.popEntryExitTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/popEntryExit/popEntryExit-state.js